export default __webpack_public_path__ + "static/7e82f4c71df5fc78abbb54a6f82ed299.svg";